import base from './base';
import commonTranslation from './commonTranslation'
export default {
  ...base,
  ...commonTranslation,
};
